import type { VenueTrustSignalDomain } from '~/shared/venue/trust-signals'

export const SPACE_SORT_OPTIONS = [
  'recommended',
  'distance',
  'date_opened',
  'capacity_low_to_high',
  'capacity_high_to_low',
  'google_rating',
] as const

export type SpaceSortBy = (typeof SPACE_SORT_OPTIONS)[number]

export const DEFAULT_SPACE_SORT_BY: SpaceSortBy = 'recommended'

export interface ListSpacesParams {
  page?: string | number
  venue_name?: string
  google_place_id?: string
  neighborhoods?: (string | number)[]
  nw?: string | null
  se?: string | null
  standing_guest_count?: string | number
  seated_guest_count?: string | number
  privacy?: string[]
  noise?: string[]
  space_types?: string[]
  outdoor_space_types?: string[]
  windows?: string[]
  amenities?: string[]
  av?: string[]
  wheelchair?: boolean | null
  f_and_b_minimum_from?: string | number
  f_and_b_minimum_to?: string | number
  cuisines?: (string | number)[]
  venue_types?: (string | number)[]
  prices?: string[]
  michelin_ratings?: string[]
  min_google_rating?: string | number
  ai_filter_tags?: string[]
  trust_signals?: VenueTrustSignalDomain[]
  venue_management_group_caliber?: 'high'
  active_venue_group_id?: number
  vibe_search?: string
  sort_by?: SpaceSortBy
  sort_origin_lat?: number
  sort_origin_lng?: number
  /** Override per_page for the Typesense query (e.g. 200 for zoomed-in map mode) */
  perPage?: number
  /**
   * Restrict results to spaces whose `venue_id` is in this list.
   *
   * Set by the venue-tag filter: when one or more tags are selected, the
   * union of their tagged venue ids ends up here. An EMPTY array means
   * "tag filter is active but no venue matches it" — caller must short-circuit
   * to zero results rather than treat undefined-vs-empty as "no filter".
   */
  venue_ids?: number[]
}
